import { render, staticRenderFns } from "./cms-block-gallery.vue?vue&type=template&id=c89e0530&scoped=true"
import script from "./cms-block-gallery.vue?vue&type=script&lang=js"
export * from "./cms-block-gallery.vue?vue&type=script&lang=js"
import style0 from "./cms-block-gallery.vue?vue&type=style&index=0&id=c89e0530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89e0530",
  null
  
)

export default component.exports